module.exports = "/_next/static/images/4879cfb6c828d7186c20f434b8be43be-woman-with-iphone@0.75x.jpg.webp";